export const canUseWorkers = () => typeof Worker === 'function';

/**
 * Invokes a worker at the specified path and returns a promise for the result.
 * Assumes that the worker responds with a single message of the format { data: Any }
 * @param {String} path The path to the worker
 * @param {Any} data Data to send to the worker
 * @param {Array<Object>} transfer Array of objects to transfer to the worker
 * @returns {Promise<Any>} A promise for the result of the worker operation.
 */
export const invokeWorkerAsync = (path, data, transfer) =>
    new Promise(function (resolve) {
        const worker = new Worker(path);

        worker.addEventListener('message', ({ data: responseData }) =>
            resolve(responseData),
        );

        worker.postMessage(data, transfer);
    });
